import { useState, useEffect, useMemo } from 'react';

const useOnScreen = (ref) => {
  const [isIntersecting, setIsIntersecting] = useState(false);

  const observer = useMemo(() => new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting)), []);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    observer.observe(node);
    return () => observer.unobserve(node);
  }, [observer, ref]);

  return isIntersecting;
};

export default useOnScreen;
